export enum InstanceEnum {
  TestInstance = 'testInstance',
  Development = 'dev',
  Staging = 'stage',
  Production = 'prod',
  Local = 'local',
  Unknown = 'unknown',
}
